export const FONT_FAMILY = "Inter";
export const INPUT_HEIGHT = 48;
